import { render, staticRenderFns } from "./AdminService.vue?vue&type=template&id=0b18cef2&"
import script from "./AdminService.vue?vue&type=script&lang=js&"
export * from "./AdminService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports